var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        _vm.$style["mds-alert"],
        _vm.classObject,
        _vm.sizeClass,
        _vm.variationClass,
      ],
      attrs: { "data-mds-version": _vm.version },
    },
    [
      _c(
        "div",
        { class: _vm.$style["mds-alert__variation"] },
        [
          _c("mds-icon", {
            class: _vm.$style["mds-alert__icon"],
            attrs: { name: _vm.variationIcon, size: _vm.iconSize },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { class: _vm.$style["mds-alert__body"] }, [
        _c(
          "div",
          { class: _vm.$style["mds-alert__content"] },
          [
            _vm.title
              ? _c("div", { class: _vm.$style["mds-alert__title"] }, [
                  _vm._v(_vm._s(_vm.title)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "p",
              { class: _vm.$style["mds-alert__message"] },
              [
                _vm._t("default", function () {
                  return [_vm._v(_vm._s(_vm.text))]
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.list
              ? _c(
                  "ul",
                  { class: _vm.$style["mds-alert__list"] },
                  _vm._l(_vm.list, function (item, index) {
                    return _c(
                      "li",
                      { key: index, class: _vm.$style["mds-alert__list-item"] },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(item) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("mds-alert-custom-action"),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      !_vm.persistent
        ? _c("mds-button", {
            class: _vm.$style["mds-alert__dismiss-button"],
            attrs: {
              size: _vm.dismissButtonSize,
              icon: "remove",
              variation: "icon-only",
              text: _vm.dismissIconAriaLabel,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("mds-alert-dismissed", $event.target)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }